import React, { useState } from "react";
import "../styles/Staff.css";

const Staff = ({ currentUserRole }) => {
  const [staff, setStaff] = useState([
    { id: 1, name: "Alice Johnson", email: "alice@example.com", role: "Admin", status: "Active" },
    { id: 2, name: "Bob Smith", email: "bob@example.com", role: "Support", status: "Inactive" },
  ]);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [newStaff, setNewStaff] = useState({ name: "", email: "", role: "Support" });
  const [editStaff, setEditStaff] = useState(null);

  // Add Staff
  const handleAddStaff = () => {
    setStaff([...staff, { id: staff.length + 1, ...newStaff, status: "Active" }]);
    setShowAddModal(false);
    setNewStaff({ name: "", email: "", role: "Support" });
  };

  // Toggle status
  const handleToggleStatus = (id) => {
    setStaff((prev) =>
      prev.map((s) =>
        s.id === id ? { ...s, status: s.status === "Active" ? "Inactive" : "Active" } : s
      )
    );
  };

  // Remove Staff
  const handleRemoveStaff = (id, role) => {
    if (role === "Admin" && currentUserRole !== "MasterAdmin") {
      alert("⛔ Only Master Admin can remove an Admin!");
      return;
    }
    setStaff(staff.filter((s) => s.id !== id));
  };

  // Open Edit Modal
  const handleOpenEdit = (staffMember) => {
    setEditStaff(staffMember);
    setShowEditModal(true);
  };

  // Save Edit
  const handleSaveEdit = () => {
    setStaff((prev) =>
      prev.map((s) => (s.id === editStaff.id ? editStaff : s))
    );
    setShowEditModal(false);
    setEditStaff(null);
  };

  return (
    <div className="staff-section">
      <div className="admin-header">
        <h2>Staff Management</h2>
        <button className="btn view" onClick={() => setShowAddModal(true)}>
          + Add Staff
        </button>
      </div>

      <table className="staff-table">
        <thead>
          <tr>
            <th>ID</th><th>Name</th><th>Email</th><th>Role</th><th>Status</th><th>Action</th>
          </tr>
        </thead>
        <tbody>
          {staff.map((s) => (
            <tr key={s.id}>
              <td>{s.id}</td>
              <td>{s.name}</td>
              <td>{s.email}</td>
              <td>
                <span className={`role ${s.role.toLowerCase()}`}>{s.role}</span>
              </td>
              <td>
                <span className={`status ${s.status === "Active" ? "success" : "failed"}`}>
                  {s.status}
                </span>
              </td>
              <td>
                <button className="btn track" onClick={() => handleToggleStatus(s.id)}>
                  {s.status === "Active" ? "Deactivate" : "Activate"}
                </button>
                <button className="btn view" onClick={() => handleOpenEdit(s)}>Edit</button>
                {currentUserRole === "MasterAdmin" && (
                  <button className="btn cancel" onClick={() => handleRemoveStaff(s.id, s.role)}>
                    Remove
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Add Staff Modal */}
      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Add New Staff</h3>
            <input
              type="text"
              placeholder="Full Name"
              value={newStaff.name}
              onChange={(e) => setNewStaff({ ...newStaff, name: e.target.value })}
            />
            <input
              type="email"
              placeholder="Email"
              value={newStaff.email}
              onChange={(e) => setNewStaff({ ...newStaff, email: e.target.value })}
            />
            <select
              value={newStaff.role}
              onChange={(e) => setNewStaff({ ...newStaff, role: e.target.value })}
            >
              <option value="Support">Support</option>
              <option value="Manager">Manager</option>
              <option value="Admin">Admin</option>
            </select>
            <div className="modal-actions">
              <button className="btn view" onClick={handleAddStaff}>Add</button>
              <button className="btn cancel" onClick={() => setShowAddModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Staff Modal */}
      {showEditModal && editStaff && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Edit Staff</h3>
            <input
              type="text"
              placeholder="Full Name"
              value={editStaff.name}
              onChange={(e) => setEditStaff({ ...editStaff, name: e.target.value })}
            />
            <input
              type="email"
              placeholder="Email"
              value={editStaff.email}
              onChange={(e) => setEditStaff({ ...editStaff, email: e.target.value })}
            />
            <select
              value={editStaff.role}
              onChange={(e) => setEditStaff({ ...editStaff, role: e.target.value })}
            >
              <option value="Support">Support</option>
              <option value="Manager">Manager</option>
              <option value="Admin">Admin</option>
            </select>
            <div className="modal-actions">
              <button className="btn view" onClick={handleSaveEdit}>Save</button>
              <button className="btn cancel" onClick={() => setShowEditModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Staff;
